import React, { ReactElement, useState } from "react";
import { DebugContext } from "./DebugContext";
import { BreakpointDebugger } from "./BreakpointDebugger";
import { useEnvironment } from "../../hooks/useEnvironment";

interface DebugProviderProps {
  children: React.ReactNode;
}

/**
 * DebugProvider - Provides debug context and renders debug tools only in development
 * 
 * This component ensures that all debug code is completely isolated and never
 * affects production builds. It only renders when isDevelopment() returns true.
 */
export function DebugProvider(props: DebugProviderProps): ReactElement {
  const [isDevelopment] = useEnvironment();
  const [isBreakpointDebuggerEnabled, setBreakpointDebuggerEnabled] = useState(false);

  // Only render debug functionality in development
  if (!isDevelopment()) {
    return <>{props.children}</>;
  }

  return (
    <DebugContext.Provider value={{ isBreakpointDebuggerEnabled, setBreakpointDebuggerEnabled }}>
      {isBreakpointDebuggerEnabled && <BreakpointDebugger />}
      {props.children}
    </DebugContext.Provider>
  );
}
